/* tslint:disable */
/* eslint-disable */
/**
 * Vipps ePayment Internal API
 * The Vipps ePayment Internal api
 *
 * The version of the OpenAPI document: 0.9.0
 * Contact: teamecom@vipps.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Currency,
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './Currency';

/**
 * 
 * @export
 * @interface Amount
 */
export interface Amount {
    /**
     * 
     * @type {Currency}
     * @memberof Amount
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof Amount
     */
    value: number;
}

export function AmountFromJSON(json: any): Amount {
    return AmountFromJSONTyped(json, false);
}

export function AmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Amount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': CurrencyFromJSON(json['currency']),
        'value': json['value'],
    };
}

export function AmountToJSON(value?: Amount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': CurrencyToJSON(value.currency),
        'value': value.value,
    };
}

